<template>
    <div class="container container--slim step-thx-page step-thx-page--payed">
        <div class="image-wrapper">
            <img class="w-80" src="@/assets/failed.png" />
        </div>
        <p class="container__subheader t-center t-bold">
            {{ $t(`${TRANSLATION_KEY}.subheader`) }}
            <br />
            <br />
            {{ $t(`${TRANSLATION_KEY}.email`) }}
            <br />
            {{ $t(`${TRANSLATION_KEY}.phone`) }}
        </p>
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue';
import { useStore } from 'vuex';
import { SET_PROGRESS } from '@/constants/mutation-types';
import { PROGRESS_BAR_TIMES } from '@/constants/progress-bar-times';

const TRANSLATION_KEY = 'steps.OnboardingDenied';

export default defineComponent({
    name: 'OnboardingDenied',
    setup() {
        const store = useStore();

        onMounted(() => {
            store.commit(SET_PROGRESS, PROGRESS_BAR_TIMES.ONBOARDING_DENIED);
        });

        return {
            TRANSLATION_KEY,
        };
    },
});
</script>
